// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1507":"ef512e04","6395":"21fff272","7528":"0855ef45"}[chunkId] + ".chunk.css";
};